export default __webpack_public_path__ + "static/media/tim_read.d143089d.jpg";